import { render, staticRenderFns } from "./SettingsBotMarketForm.vue?vue&type=template&id=20c05cea&"
import script from "./SettingsBotMarketForm.vue?vue&type=script&lang=js&"
export * from "./SettingsBotMarketForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports